/** external */
import React, { useEffect } from "react";
import classNames from "classnames";
import { ToggleSwitch } from "@toddle-edu/ds-web";

/** internal */
import { useI18n } from "Hooks";

/** relative */
import classes from "./ShortcutSettingsPage.scss";

const ToggleSwitchItem = props => {
  const { label, subtext, checked, onChange, disabled, testId } = props;

  const subtextClasses = classNames("text-body-s", classes.subtext);

  return (
    <div className={classes.item}>
      <div>
        <div>{label}</div>
        <div className={subtextClasses}>{subtext}</div>
      </div>

      <ToggleSwitch
        dsVersion="2.0"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        testId={testId}
      />
    </div>
  );
};

const ShortcutSettingsPage = props => {
  const {
    testId,
    areShortcutsEnabled,
    areShortcutPromptsEnabled,
    updateSettingsValue,
    resetSettingsValue,
  } = props;

  const localTestId = `${testId}-shortcutSettingsPage`;

  useEffect(() => {
    return resetSettingsValue;
  }, []);

  const { t } = useI18n(["common"]);

  return (
    <div className={classes.container}>
      <ToggleSwitchItem
        label={t("common:enable_with_label_lowercase", {
          label: t("common:shortcut_plural"),
        })}
        subtext={t("common:shortcut_preference_subtitle")}
        checked={areShortcutsEnabled}
        onChange={e =>
          updateSettingsValue({ areShortcutsEnabled: e.target.checked })
        }
        testId={`${localTestId}-shortcutPreference`}
      />

      <ToggleSwitchItem
        label={t("common:enable_with_label_lowercase", {
          label: t("common:prompt_plural"),
        })}
        subtext={t("common:shortcut_prompts_preference_subtitle")}
        checked={areShortcutPromptsEnabled}
        onChange={e =>
          updateSettingsValue({ areShortcutPromptsEnabled: e.target.checked })
        }
        disabled={!areShortcutsEnabled}
        testId={`${localTestId}-shortcutPromptPreference`}
      />
    </div>
  );
};

export default ShortcutSettingsPage;
